import { Stack, Typography } from '@mui/material'
import { SummaryElement } from '../../MidYear/Summary/components/SummaryElement'
import { type SurveyContent } from '../../MidYear/Summary/MidYearSummary'

interface Props {
  content: SurveyContent
  answers: Record<string, any>
}
export const RCNEndOfYearSummary = ({ content, answers }: Props): JSX.Element => {
  return (<>
    <Typography variant='h3'>
      RCN Operations
    </Typography>

    {content.pages.map((page, pageIndex) => (
      <Stack key={pageIndex} gap='24px'>
        <Typography variant='h4'>{page.title}</Typography>
        {page.elements.map((element) => (
          <SummaryElement key={element.name} element={element} answers={answers} />
        ))}
      </Stack>
    ))}
  </>)
}
